import React, { useState } from "react";
import { HiOutlineBars3BottomRight } from "react-icons/hi2";
import { MdOutlineClose } from "react-icons/md";
import { Link } from "react-router-dom";
import Scroll from "react-scroll";
const ScrollLink = Scroll.Link;

const NavBar = () => {
  const [bars, setBars] = useState(false);
  const menuItems = (
    <>
      <li className="flex items-center pr-2 cursor-pointer capitalize font-normal text-white hover:text-secondary hover:scale-105 duration-200">
        <Link to="/">Home</Link>
      </li>
      <li
        // onClick={() => window.location.replace("/#aboutMe")}
        className="flex items-center pr-2 cursor-pointer capitalize font-normal text-white hover:text-secondary hover:scale-105 duration-200"
      >
        <ScrollLink to="aboutMe" spy={true} smooth={true} duration={1000}>
          About Me
        </ScrollLink>
      </li>
      <li className="flex items-center pr-2 cursor-pointer capitalize font-normal text-white hover:text-secondary hover:scale-105 duration-200">
        <Link>Resume</Link>
      </li>
      <li className="flex items-center pr-2 cursor-pointer capitalize font-normal text-white hover:text-secondary hover:scale-105 duration-200">
        <Link to="/blog">Blog</Link>
      </li>
      <li className="flex items-center pr-2 cursor-pointer capitalize font-normal text-white hover:text-secondary hover:scale-105 duration-200">
        <ScrollLink
          to="contactSection"
          spy={true}
          smooth={true}
          duration={1000}
        >
          Contact
        </ScrollLink>
      </li>
    </>
  );
  return (
    <header className="p-4 bg-main text-white ">
      <div className="container flex justify-between h-16 mx-auto">
        <p className="font-signature flex items-center p-2 text-4xl ">
          <span className="text-secondary">M</span>ostafizur
          <span className="text-secondary">.</span>
        </p>
        <ul className="items-stretch hidden space-x-3 md:flex">{menuItems}</ul>
        <div
          onClick={() => setBars(!bars)}
          className="flex justify-end p-4 md:hidden cursor-pointer text-secondary z-10 font-light"
        >
          {bars ? (
            <MdOutlineClose size={35} />
          ) : (
            <HiOutlineBars3BottomRight size={35}></HiOutlineBars3BottomRight>
          )}
        </div>
      </div>
      {bars && (
        <ul className="flex flex-col md:hidden justify-center items-center absolute top-0 left-0 w-full h-screen bg-main text-white">
          {menuItems}
        </ul>
      )}
    </header>
  );
};

export default NavBar;
